import React from 'react';
import { useEditorStore } from '../../store/editorStore';
import { useShallow } from 'zustand/react/shallow';
import { DcInspector } from './DcInspector';
import { RackInspector } from './RackInspector';

interface Props {
  selectedId: string | null;
  dcCode?: string;
}

export const PropertiesEditor: React.FC<Props> = ({ selectedId, dcCode }) => {
  const { racks, updateRack, deleteRack, clearSelection, addRacksBatch, rows, dcSettings } = useEditorStore(useShallow(state => ({
    racks: state.racks,
    updateRack: state.updateRack, deleteRack: state.deleteRack, clearSelection: state.clearSelection,
    addRacksBatch: state.addRacksBatch, rows: state.rows, dcSettings: state.dcSettings
  })));

  const rack = selectedId ? racks[selectedId] : undefined;

  if (rack) {
    const racksCountByRow: Record<string, number> = {};
    Object.values(racks).forEach(r => {
      if (r.rowId) racksCountByRow[r.rowId] = (racksCountByRow[r.rowId] || 0) + 1;
    });

    return <RackInspector 
      rack={rack} 
      dcCode={dcCode}
      rows={rows}
      dcSettings={dcSettings}
      racksCountByRow={racksCountByRow}
      onUpdate={(id, updates) => updateRack(id, updates)}
      onDelete={(id) => { deleteRack(id); clearSelection(); }}
      onGenerateRow={(newRacks) => addRacksBatch(newRacks)}
    />;
  }

  return <DcInspector dcCode={dcCode} />;
};
